module.exports = {"321023100":"安宜镇","321023101":"氾水镇","321023102":"夏集镇","321023103":"柳堡镇","321023104":"射阳湖镇","321023105":"广洋湖镇","321023106":"鲁垛镇","321023107":"小官庄镇","321023108":"望直港镇","321023109":"曹甸镇","321023110":"西安丰镇","321023111":"山阳镇","321023112":"黄塍镇","321023113":"泾河镇","321023400":"开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321023.json
// module id = 1017
// module chunks = 0